var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 83,
    height: 83,
    viewBox: "0 0 83 83",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3602 57.01C0.0379921 59.6013 2.62935 31.0964 23.3602 33.6877C15.5862 5.18275 59.6393 5.18276 57.0479 25.9136C82.9616 18.1396 82.9616 59.6013 59.6393 57.01M28.543 46.6445L41.4998 36.2791M41.4998 36.2791L54.4566 46.6445M41.4998 36.2791V75.1495",
    stroke: "#3A0DBB",
    strokeWidth: 3.52866,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUpload);
export default __webpack_public_path__ + "static/media/FileUpload.f62b95a244d6e1da98bcd8fb861396ed.svg";
export { ForwardRef as ReactComponent };